<div class="loading-container" *ngIf="loading">
	<div class="lds-facebook">
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>

<div class="form-container configure" [ngClass]="{'hidden': loading }">
	<div class="show-help-container">
		<i *ngIf="!showHelp" class="fas fa-question" title="Show help" (click)="showHelp = true"></i>
		<i *ngIf="showHelp" class="fas fa-question" title="Hide help" (click)="showHelp = false"></i>
	</div>

	<div class="group">
		<div class="group-container">
			<div class="message" (click)="showCommunicationExpanded = !showCommunicationExpanded">
				<em *ngIf="!showCommunicationExpanded" class="fas fa-angle-down expand"></em>
				<em *ngIf="showCommunicationExpanded" class="fas fa-angle-up expand"></em>
				<div class="group-title">Communication Settings</div>
			</div>
			<div class="data" [ngClass]="{'hidden': !showCommunicationExpanded}">
				<div class="field-container last">
					<label for="dropboxSignDefaultMessage" class="input-label">Default E-mail Message:</label>
					<div *ngIf="showHelp" class="help-text">The custom message in the e-mail that will be sent to the signers.</div>
					<textarea id="dropboxSignDefaultMessage" [(ngModel)]="clientDetailProcore.dropboxSignDefaultMessage" class="client-info-textarea"></textarea>
				</div>
			</div>
		</div>

		<div class="group-container">
			<div class="message" (click)="showWorkflowExpanded = !showWorkflowExpanded">
				<em *ngIf="!showWorkflowExpanded" class="fas fa-angle-down expand"></em>
				<em *ngIf="showWorkflowExpanded" class="fas fa-angle-up expand"></em>
				<div class="group-title">Workflow Settings</div>
			</div>
			<div class="data" [ngClass]="{'hidden': !showWorkflowExpanded}">
				<div class="field-container">
					<label for="poStatusAfterRequested" class="input-label">Update Status of a Commitment Purchase Order after signature requested:</label>
					<div *ngIf="showHelp" class="help-text">If selected, the Status of a Commitment Purchase Order will be automatically changed to the specified status after a signature request has been sent.</div>
					<ng-select id="poStatusAfterRequested" [(ngModel)]="clientDetailProcore.poStatusAfterRequested">
						<ng-option value=""></ng-option>
						<ng-option value="Draft">Draft</ng-option>
						<ng-option value="Processing">Processing</ng-option>
						<ng-option value="Submitted">Submitted</ng-option>
						<ng-option value="Partially Received">Partially Received</ng-option>
						<ng-option value="Received">Received</ng-option>
						<ng-option value="Approved">Approved</ng-option>
						<ng-option value="Closed">Closed</ng-option>
					</ng-select>
				</div>
				<div class="field-container">
					<label for="poStatusAfterCompleted" class="input-label">Update Status of a Commitment Purchase Order after signature completed:</label>
					<div *ngIf="showHelp" class="help-text">If selected, the Status of a Commitment Purchase Order will be automatically changed to the specified status after a signature request has been completed.</div>
					<ng-select id="poStatusAfterCompleted" [(ngModel)]="clientDetailProcore.poStatusAfterCompleted">
						<ng-option value=""></ng-option>
						<ng-option value="Draft">Draft</ng-option>
						<ng-option value="Processing">Processing</ng-option>
						<ng-option value="Submitted">Submitted</ng-option>
						<ng-option value="Partially Received">Partially Received</ng-option>
						<ng-option value="Received">Received</ng-option>
						<ng-option value="Approved">Approved</ng-option>
						<ng-option value="Closed">Closed</ng-option>
					</ng-select>
				</div>
				<div class="field-container">
					<label for="scStatusAfterRequested" class="input-label">Update Status of Commitment Subcontract after signature requested:</label>
					<div *ngIf="showHelp" class="help-text">If selected, the Status of a Commitment Subcontract will be automatically changed to the specified status after a signature request has been requested.</div>
					<ng-select id="scStatusAfterRequested" [(ngModel)]="clientDetailProcore.scStatusAfterRequested">
						<ng-option value=""></ng-option>
						<ng-option value="Draft">Draft</ng-option>
						<ng-option value="Out For Bid">Out For Bid</ng-option>
						<ng-option value="Out For Signature">Out For Signature</ng-option>
						<ng-option value="Approved">Approved</ng-option>
						<ng-option value="Complete">Complete</ng-option>
						<ng-option value="Terminated">Terminated</ng-option>
						<ng-option value="Void">Void</ng-option>
					</ng-select>
				</div>
				<div class="field-container">
					<label for="scStatusAfterCompleted" class="input-label">Update Status of Commitment Subcontract after signature completed:</label>
					<div *ngIf="showHelp" class="help-text">If selected, the Status of a Commitment Subcontract will be automatically changed to the specified status after a signature request has been completed.</div>
					<ng-select id="scStatusAfterCompleted" [(ngModel)]="clientDetailProcore.scStatusAfterCompleted">
						<ng-option value=""></ng-option>
						<ng-option value="Draft">Draft</ng-option>
						<ng-option value="Out For Bid">Out For Bid</ng-option>
						<ng-option value="Out For Signature">Out For Signature</ng-option>
						<ng-option value="Approved">Approved</ng-option>
						<ng-option value="Complete">Complete</ng-option>
						<ng-option value="Terminated">Terminated</ng-option>
						<ng-option value="Void">Void</ng-option>
					</ng-select>
				</div>
				<div class="field-container">
					<label for="pcStatusAfterRequested" class="input-label">Update Status of Prime Contract after signature requested:</label>
					<div *ngIf="showHelp" class="help-text">If selected, the Status of a Prime Contract will be automatically changed to the specified status after a signature request has been requested.</div>
					<ng-select id="pcStatusAfterRequested" [(ngModel)]="clientDetailProcore.pcStatusAfterRequested">
						<ng-option value=""></ng-option>
						<ng-option value="Draft">Draft</ng-option>
						<ng-option value="Out For Bid">Out For Bid</ng-option>
						<ng-option value="Out For Signature">Out For Signature</ng-option>
						<ng-option value="Approved">Approved</ng-option>
						<ng-option value="Complete">Complete</ng-option>
						<ng-option value="Terminated">Terminated</ng-option>
					</ng-select>
				</div>
				<div class="field-container">
					<label for="pcStatusAfterCompleted" class="input-label">Update Status of Prime Contract after signature completed:</label>
					<div *ngIf="showHelp" class="help-text">If selected, the Status of a Prime Contract will be automatically changed to the specified status after a signature request has been completed.</div>
					<ng-select id="pcStatusAfterCompleted" [(ngModel)]="clientDetailProcore.pcStatusAfterCompleted">
						<ng-option value=""></ng-option>
						<ng-option value="Draft">Draft</ng-option>
						<ng-option value="Out For Bid">Out For Bid</ng-option>
						<ng-option value="Out For Signature">Out For Signature</ng-option>
						<ng-option value="Approved">Approved</ng-option>
						<ng-option value="Complete">Complete</ng-option>
						<ng-option value="Terminated">Terminated</ng-option>
					</ng-select>
				</div>
				<div class="field-container last switch-row">
					<label for="setExcutedAfterCompleted" class="input-label">Mark as executed after signature complete:</label>
					<div *ngIf="showHelp" class="help-text">Attempt to automatically mark a contract as executed after a signature request has been completed. This will only work if workflows are not in place.</div>
					<div class="switch block">
						<input id="setExcutedAfterCompleted" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.setExcutedAfterCompleted">
						<label for="setExcutedAfterCompleted" class="switch-label">Switch</label>
					</div>
				</div>
			</div>
		</div>

		<div class="group-container">
			<div class="message" (click)="showRequestExpanded = !showRequestExpanded">
				<em *ngIf="!showRequestExpanded" class="fas fa-angle-down expand"></em>
				<em *ngIf="showRequestExpanded" class="fas fa-angle-up expand"></em>
				<div class="group-title">Signing Request Options</div>
			</div>
			<div class="data" [ngClass]="{'hidden': !showRequestExpanded}">
				<div class="field-container switch-row">
					<label for="useExportedFile" class="input-label">Use Exported File Where Available:</label>
					<div *ngIf="showHelp" class="help-text">Automatically exports the Procore file and attaches it to the request. Currently available on Prime Contracts, Commitments, Prime Contract Change Orders, and Commitment Change Orders.</div>
					<div class="switch block">
						<input id="useExportedFile" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.useExportedFile">
						<label for="useExportedFile" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="field-container switch-row">
					<label for="enableMultipleAttachments" class="input-label">Enable Multiple Attachments:</label>
					<div *ngIf="showHelp" class="help-text">When enabled, attachments can be selected to be sent for signature alongside the main contract.</div>
					<div class="switch block">
						<input id="enableMultipleAttachments" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.enableMultipleAttachments">
						<label for="enableMultipleAttachments" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="field-container switch-row last">
					<label for="allowExpirationDate" class="input-label">Allow setting an expiration date:</label>
					<div *ngIf="showHelp" class="help-text">Allow setting an enforced expiration date for the signature request.</div>
					<div class="switch block">
						<input id="allowExpirationDate" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.allowExpirationDate">
						<label for="allowExpirationDate" class="switch-label">Switch</label>
					</div>
				</div>
			</div>
		</div>

		<div class="group-container">
			<div class="message" (click)="showStorageExpanded = !showStorageExpanded">
				<em *ngIf="!showStorageExpanded" class="fas fa-angle-down expand"></em>
				<em *ngIf="showStorageExpanded" class="fas fa-angle-up expand"></em>
				<div class="group-title">Storage Settings</div>
			</div>
			<div class="data" [ngClass]="{'hidden': !showStorageExpanded}">
				<div class="field-container switch-row">
					<label for="allowDefaultLocationOverride" class="input-label">Allow Overriding Default Locations:</label>
					<div *ngIf="showHelp" class="help-text">When enabled, users can override the file storage location when sending a request.</div>
					<div class="switch block">
						<input id="allowDefaultLocationOverride" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="projectConfigs.allowDefaultLocationOverride">
						<label for="allowDefaultLocationOverride" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="field-container last">
					<label class="input-label">Default File Storage Locations:</label>
					<div *ngIf="showHelp" class="help-text">Specifies where the signed document should be stored after all parties have signed. These settings are specific to the current project.</div>
					<br />
					<label for="primeContractStorage" class="input-label">Prime Contracts:</label>
					<ng-select id="primeContractStorage" [(ngModel)]="projectConfigs.primeContractStorage">
						<ng-option value="default">Prime Contract</ng-option>
						<ng-option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</ng-option>
					</ng-select>
					<label for="primeContractCoStorage" class="input-label">Prime Contract Change Orders:</label>
					<ng-select id="primeContractCoStorage" [(ngModel)]="projectConfigs.primeContractCoStorage">
						<ng-option value="default">Prime Contract</ng-option>
						<ng-option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</ng-option>
					</ng-select>
					<label for="primeContractPcoStorage" class="input-label">Prime Contract Potential Change Orders:</label>
					<ng-select id="primeContractPcoStorage" [(ngModel)]="projectConfigs.primeContractPcoStorage">
						<ng-option value="default">Prime Contract</ng-option>
						<ng-option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</ng-option>
					</ng-select>
					<label for="subcontractStorage" class="input-label">Subcontracts:</label>
					<ng-select id="subcontractStorage" [(ngModel)]="projectConfigs.subcontractStorage">
						<ng-option value="default">Subcontract</ng-option>
						<ng-option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</ng-option>
					</ng-select>
					<label for="subcontractCoStorage" class="input-label">Subcontract Change Orders:</label>
					<ng-select id="subcontractCoStorage" [(ngModel)]="projectConfigs.subcontractCoStorage">
						<ng-option value="default">Subcontract</ng-option>
						<ng-option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</ng-option>
					</ng-select>
					<label for="subcontractPcoStorage" class="input-label">Subcontract Potential Change Orders:</label>
					<ng-select id="subcontractPcoStorage" [(ngModel)]="projectConfigs.subcontractPcoStorage">
						<ng-option value="default">Subcontract</ng-option>
						<ng-option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</ng-option>
					</ng-select>
					<label for="purchaseOrderStorage" class="input-label">Purchase Orders:</label>
					<ng-select id="purchaseOrderStorage" [(ngModel)]="projectConfigs.purchaseOrderStorage">
						<ng-option value="default">Purchase Order</ng-option>
						<ng-option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</ng-option>
					</ng-select>
					<label for="purchaseOrderCoStorage" class="input-label">Purchase Order Change Order:</label>
					<ng-select id="purchaseOrderCoStorage" [(ngModel)]="projectConfigs.purchaseOrderCoStorage">
						<ng-option value="default">Purchase Order</ng-option>
						<ng-option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</ng-option>
					</ng-select>
					<label for="purchaseOrderPcoStorage" class="input-label">Purchase Order Potential Change Order:</label>
					<ng-select id="purchaseOrderPcoStorage" [(ngModel)]="projectConfigs.purchaseOrderPcoStorage">
						<ng-option value="default">Purchase Order</ng-option>
						<ng-option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</ng-option>
					</ng-select>
				</div>
			</div>
		</div>
		<div class="button-container right">
			<button type="button" class="btn btn-success" (click)="updateConfigurations()">Save</button>
			<button type="button" class="btn secondary" (click)="cancelConfigurations()">Cancel</button>
		</div>
	</div>
</div>